import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DiscountType } from '../../models/discount';
import { MultiselectItem } from '../../../core/interfaces/admin.interface';
import { TranslateService } from '@ngx-translate/core';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-discount-type-select',
  templateUrl: './discount-type-select.component.html',
  styleUrls: ['./discount-type-select.component.scss']
})
export class DiscountTypeSelectComponent {

  @Input() typeSelected: MultiselectItem[] = [];

  @Input() disabled: boolean = false;

  @Output() typeSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  typeList: MultiselectItem[] = [];

  constructor(
    private translate: TranslateService,
  ) {

    this.typeList = [
      { id: DiscountType.AMOUNT, itemName: this.translate.instant('multiselect.discountType.' + DiscountType.AMOUNT) },
      { id: DiscountType.PERCENTAGE, itemName: this.translate.instant('multiselect.discountType.' + DiscountType.PERCENTAGE) },
      { id: DiscountType.FINAL_PRICE, itemName: this.translate.instant('multiselect.discountType.' + DiscountType.FINAL_PRICE) }
    ]

  }

  onTypeSelect(): void {
    this.typeSelectedChange.emit(this.typeSelected);
    this.onSelected.emit(this.typeSelected);
  }

}
